/**
 * Router
 */
import React, { Fragment, useContext } from 'react';
import { Switch, Route, withRouter, useLocation } from 'react-router-dom';
import Wos from './without-sidemenu';
import Ws from './with-sidemenu';
import Can from './components/Can';
import AuthContext from './authContext';

// React
// Components

//partner
import Centers from './pages/centers';
import CenterDetails from './pages/centers/components/detail';
import CenterEdit from './pages/centers/components/edit';
import CenterAdd from './pages/centers/components/add';
import Login from './pages/login';
import OrderDetails from './pages/orderDetails';
import VitrinOrderDetails from './pages/orderDetails/vitrin';
import ExitReceipt from './pages/orderPack/components/exitRecipt';
import OrderLogs from './pages/orderLogs';
import Orders from './pages/orders';
import ExitReceiptGroup from './pages/orderPack/printexitreceipt/exitRecipt';
import Helpdesk from './pages/orders/helpdesk';
import HelpicalParcel from './pages/parcelDetails/helpicalParcel';
import ParcelDetails from './pages/parcelDetails';
import ParcelConflicts from './pages/parcelConflicts';
import ParcelReceipts from './pages/parcelDetails/receipt';
import ParcelLogs from './pages/parcelLogs';
import ParcelsSender from './pages/parcelsSender';
import ParcelsSenderCreate from './pages/parcelsSender/components/Add/add';
import GroupingCreateParcel from './pages/parcelsSender/components/Add/groupingCreate';
import ParcelsSenderEdit from './pages/parcelsSender/components/Edit/edit';
import PartnersAccount from './pages/partnerAccount/detail';
import Products from './pages/products';
import ProductsVitrin from './pages/products/indexVitrin';
import ProductsDetail from './pages/products/product';
import ProductsVariant from './pages/products/variant';
import ProductsVariantInventoryItems from './pages/products/variantInventory';
import SkusInventoryDetails from './pages/warehouseInventory/skuInventoryDetails';
import VariantOrders from './pages/orders/variantOrders';
import Webhooks from './pages/webhooks';
import WebhooksCreate from './pages/webhooks/add';
import Providers from './pages/providers';
import ProviderAdd from './pages/providers/components/Add';
import Notification from './pages/notification';
import Sellers from './pages/sellers';
import SellerAdd from './pages/sellers/components/Add';
import CreateProduct from './pages/createProduct';
import PrintLabels from './pages/parcelInventoryItems/printLabel';
import CreateOrder from './pages/createOrder';
import GroupingCreateOrder from './pages/createOrder/groupingCreate';
import GroupingAddProduct from './pages/createProduct/groupingAddProduct';
import EditVariants from './pages/editVariants';
import PartnerWarehouseInventory from './pages/partnerWarehouseInventory';
import GroupingCreateInventory from './pages/partnerWarehouseInventory/components/groupingCreate';
import InventoryDetailsMobile from './pages/partnerWarehouseInventory/components/detail';
import HelpicalDetails from './pages/orders/helpicalDetails';
import AllHelpicalDetails from './components/Notification/helpicalDetails';
import HelpicalParcelDetails from './pages/parcelDetails/helpicalParcelDetails';
import WarehouseAdminParcelsReceipt from './pages/warehouseAdminParcelsReceipt';
import Payment from './pages/payment';
import InvoiceDetails from './pages/payment/components/details';
import PaymentProcess from './pages/payment/components/process';
//center
import DeliveryOrders from './pages/deliveryOrders';
import VitrinOrders from './pages/vitrinOrder';
import IncomingOrders from './pages/incomingOrders';
//agency
import CenterOrders from './pages/reports/centerOrders';
import CurrentOrders from './pages/reports';
//seller
import SellerOrder from './pages/orders/sellerOrder';
import SellerProducts from './pages/products/sellerProducts';
import SellerProductDetail from './pages/products/SellerProductDetail';
import SellerParcels from './pages/sellerParcelsSender';
import SellerParcelsCreate from './pages/sellerParcelsSender/components/Add/add';
import SellerParcelsEdit from './pages/sellerParcelsSender/components/Edit/edit';
import InventoryEditMobile from './pages/partnerWarehouseInventory/components/edit/inventoryEdit';
import ReturnedOrder from './pages/returnedOrder';
import ResendOrder from './pages/editResendOrder/editResendOrder';
import allHelpical from './components/Notification/allHelpical';
import Categories from './pages/vitrin/categories';
import VitrinProducts from './pages/vitrin/products';
import SingleProduct from './pages/vitrin/singleProduct';

// import Partners from './pages/partners';// why not
import PayRedirect from './pages/payment/components/redirect';
import Profile from './pages/profile';

//Packaging
import PackagingPreferences from './pages/packaging/preferences';
import PackConsumption from './pages/packaging/consumption';
import CrossDoc from './pages/crossDoc';
import TokenManagement from './pages/tokenManagement'
import GroupingUpdateProduct from './pages/createProduct/groupingUpdateProduct';

// Type
export type Routes = RouteInterface[];
export type RouteInterface = {
  component: Function;
  path: string;
  routes?: string;
};

// Const routes
export const routes: Routes = [
  {
    path: '/products/:partnerId',
    component: Products,
    //wos
  },
  {
    path: '/login',
    component: Login,
    //wos
  },
  {
    path: '/orders',
    component: Orders,
  },
  {
    path: '/vitrin-orders',
    component: VitrinOrders,
  },
  {
    path: '/incoming-orders',
    component: IncomingOrders,
  },
  {
    path: '/orders/exit-receiptsgroup/:id',
    component: ExitReceiptGroup,
  },
  {
    path: '/orders/exit-receipts/:id',
    component: ExitReceipt,
  },
  {
    path: '/orders/helpdesk/:id',
    component: Helpdesk,
  },
  {
    path: '/alltickets',
    component: allHelpical,
  },
  {
    path: `/parcel/helpical-parcel/:id`,
    component: HelpicalParcel,
  },
  {
    path: '/orders/helpical/detail/:id',
    component: HelpicalDetails,
  },
  {
    path: '/alltickets/helpical/detail/:id',
    component: AllHelpicalDetails,
  },
  {
    path: '/parcel/helpical/detail/:id',
    component: HelpicalParcelDetails,
  },
  {
    path: '/seller-orders',
    component: SellerOrder,
  },
  {
    path: '/seller-products',
    component: Products,
  },
  {
    path: '/seller-products/:id',
    component: SellerProductDetail,
  },
  {
    path: '/orders-create',
    component: CreateOrder,
  },
  {
    path: '/crossdock',
    component: CrossDoc,
  },
  {
    path: '/crossdock/:id',
    component: CrossDoc,
  },
  {
    path: '/create-grouping-order',
    component: GroupingCreateOrder,
  },
  {
    path: '/create-grouping-parcel',
    component: GroupingCreateParcel,
  },
  {
    path: '/create-grouping-inventory',
    component: GroupingCreateInventory,
  },
  {
    path: '/warehouse-admin-parcels-receipts',
    component: WarehouseAdminParcelsReceipt,
  },
  {
    path: '/edit-order/:id',
    component: CreateOrder,
  },
  {
    path: '/orders/variantOrders/:id',
    component: VariantOrders,
  },
  {
    path: '/webhooks',
    component: Webhooks,
  },
  {
    path: '/webhooks/create',
    component: WebhooksCreate,
  },
  {
    path: '/orders/:id',
    component: OrderDetails,
  },
  {
    path: '/orders/vitrin/:id',
    component: VitrinOrderDetails,
  },
  {
    path: '/partner-account',
    component: PartnersAccount,
  },
  {
    path: '/partner-warehouses/inventory',
    component: PartnerWarehouseInventory,
  },
  {
    path: '/partner-warehouses/inventory/:id',
    component: InventoryDetailsMobile,
  },
  {
    path: '/partner-warehouses/inventory/edit/:id/:warehouseId',
    component: InventoryEditMobile,
  },
  {
    path: '/centers',
    component: Centers,
  },
  {
    path: '/your-centers',
    component: Centers,
  },
  {
    path: '/centers/:partnerId',
    component: Centers,
  },
  {
    path: '/centerdetails/:centerId/',
    component: CenterDetails,
  },
  {
    path: '/centeredit/:centerId/',
    component: CenterEdit,
  },
  {
    path: '/centeradd',
    component: CenterAdd,
  },
  {
    path: '/products',
    component: Products,
  },
  {
    path: '/profile',
    component: Profile,
  },
  {
    path: '/variant-edit/:id',
    component: EditVariants,
  },
  {
    path: '/your-products/:id',
    component: ProductsDetail,
  },
  {
    path: '/your-products/:id/variant/:variantId',
    component: ProductsVariant,
  },
  {
    path: '/your-products/:name/variant/:variantId/inventory-items/:warehouseId',
    component: ProductsVariantInventoryItems,
  },
  {
    path: '/your-products',
    component: Products,
  },
  {
    path: '/vitrin-your-products',
    component: ProductsVitrin,
  },
  {
    path: '/integration',
    component: TokenManagement,
  },
  {
    path: '/create-product',
    component: CreateProduct,
  },
  {
    path: '/create-grouping-product',
    component: GroupingAddProduct,
  },
  {
    path: '/update-grouping-product',
    component: GroupingUpdateProduct,
  },
  {
    path: '/edit-product/:id',
    component: CreateProduct,
  },
  {
    path: '/skus/inventory/:skuId/:name',
    component: SkusInventoryDetails,
  },
  {
    path: '/orders/:id/allLogs',
    component: OrderLogs,
  },
  {
    path: '/reports/current-orders',
    component: CurrentOrders,
  },
  {
    path: '/reports/center-orders/:centerId',
    component: CenterOrders,
  },
  {
    path: '/delivery-orders',
    component: DeliveryOrders,
  },
  {
    path: '/parcels/:id/allLogs',
    component: ParcelLogs,
  },
  {
    path: '/parcels-sender/:id/conflicts',
    component: ParcelConflicts,
  },
  {
    path: '/parcels/details/:id',
    component: ParcelDetails,
  },
  {
    path: '/parcels/receipts/:id',
    component: ParcelReceipts,
    //wos
  },
  {
    path: '/print-labels/:id',
    component: PrintLabels,
    //wos
  },
  {
    path: '/parcels-sender',
    component: ParcelsSender,
  },
  {
    path: '/parcels-sender/add',
    component: ParcelsSenderCreate,
  },
  {
    path: '/parcels-sender/:id/edit',
    component: ParcelsSenderEdit,
  },
  {
    path: '/seller-parcels',
    component: SellerParcels,
  },
  {
    path: '/seller-parcels/add',
    component: SellerParcelsCreate,
  },
  {
    path: '/seller-parcels/:id/edit',
    component: SellerParcelsEdit,
  },
  {
    path: '/parcels-sender/:id/allLogs',
    component: ParcelLogs,
  },
  {
    path: '/providers',
    component: Providers,
  },
  {
    path: '/providerAdd',
    component: ProviderAdd,
  },
  {
    path: '/notification',
    component: Notification,
  },
  {
    path: '/sellers',
    component: Sellers,
  },
  {
    path: '/sellerAdd',
    component: SellerAdd,
  },
  {
    path: '/orders-returned',
    component: ReturnedOrder,
  },
  {
    path: '/orders-resend/:id',
    component: ResendOrder,
  },
  {
    path: '/vitrin/categories',
    component: Categories,
  },
  {
    path: '/vitrin/products',
    component: VitrinProducts,
  },
  {
    path: '/vitrin/products/:id',
    component: SingleProduct,
  },
  {
    path: '/financial-management',
    component: Payment,
  },
  {
    path: '/invoice/:id',
    component: InvoiceDetails,
  },
  {
    path: '/pay-process/:id',
    component: PaymentProcess,
  },
  {
    path: '/redirect',
    component: PayRedirect,
  },
  {
    path: '/packaging-preferences',
    component: PackagingPreferences,
  },
  {
    path: '/packaging-consumption-report',
    component: PackConsumption,
  }
];
const Referee = () => {
  const { pathname } = useLocation();
  const filters: string[] = [
    '/login',
    '/post-orders/receipts/',
    '/orders/receipts/',
    '/orders/exit-receipts/',
    '/orders/post/exit-receipts',
    // '/orders/receipt/bulk',
    '/products/',
    '/parcels/receipts/',
    '/print-labels/',
    '/post-print-labels/',
    '/post-orders/post-receipt',
    '/deliver-driver-receipt',
    '/vitrin/categories',
    '/vitrin/products',
    '/vitrin/products/:id',
    '/redirect'
  ];

  const wosidebare = filters.filter(route => {
    return pathname.includes(route);
  });
  return (
    <Fragment>
      <Switch>
        {wosidebare[0] == undefined ? (
          <Route path="/" component={Ws} />
        ) : (
          <Route path="/" component={Wos} />
        )}
      </Switch>
    </Fragment>
  );
};

export default withRouter(Referee);
const checkAuth = () => localStorage.getItem('token') !== null;
// A special wrapper for <Route> that knows how to
// handle "sub"-routes by passing them in a `routes`
// prop to the component it renders.
export function RouteWithSubRoutes(route: RouteInterface) {
  const authContext = useContext(AuthContext);
  return (
    <Can
      role={authContext.user.role}
      perform={route.path}
      yes={() => (
        <Route
          exact
          path={route.path}
          render={props => {
            if (!checkAuth()) {
              window.location.reload();
              // eslint-disable-next-line react/prop-types
              props.history.push('/login');
            }
            return <route.component {...props} routes={route.routes} />;
          }}
        />
      )}
    />
  );
}
